module.exports = __webpack_public_path__ + "static/img/kb-card-img-02-03@m.5e4be95.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/kb-card/kb-card-img-02-03@m.jpg
// module id = vHLa
// module chunks = 0